import axios from "axios";

function getHeaders() {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
}

export const getLeadConversionReport = async (graphType) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/dashboard/api/lead-report/lead_conversion_report/?graph_type=${graphType}`,
      getHeaders()
    );
    return response.data; // Return the entire response (data and list)
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch lead conversion report"
    );
  }
};
